import { Hex, size, concat, sliceHex } from "viem";
// import { writeContract } from "viem/actions";
import { getAction } from "viem/utils";
import { contract } from "./contract";
import { ConnectedClient } from "./common";
import { storeSync } from "./storeSync";
import { getUserOperationReceipt, sendUserOperation, SmartAccount } from "viem/account-abstraction";
import { writeContract } from "viem/actions";
import { Subject } from "rxjs";

export const outbound = new Subject<Hex>();
export const inbound = new Subject<Hex>();
const DEBUG = localStorage.getItem("debug");

let timeBefore: number;
function logTime(msg: string) {
  if (!DEBUG) return;
  if (!timeBefore) timeBefore = Date.now();
  console.log(msg, Date.now() - timeBefore);
  timeBefore = Date.now();
}

export async function submitBatch(
  client: ConnectedClient,
  matchId: number,
  batch: Hex[],
  options?: { useWriteContract?: boolean },
): Promise<{ txHash: Hex; roundtrip: number } | undefined> {
  logTime("roundtrip: call submit batch");
  if (batch.length === 0) return;
  const lengths = batch.map((packet) => size(packet));
  const data = concat(batch);

  const timeBefore = Date.now();
  let txHash: Hex;
  if (options?.useWriteContract) {
    txHash = await getAction(
      client,
      writeContract,
      "writeContract",
    )({
      ...contract,
      functionName: "send",
      // TODO: add matchId logic
      args: [matchId, lengths, data],
      account: client.account!,
      maxFeePerGas: 10_000n,
      maxPriorityFeePerGas: 1n,
      gas: 500_000n,
    });
    logTime("roundtrip: write contract took");
  } else {
    const userOpHash = await getAction(
      client,
      sendUserOperation,
      "sendUserOperation",
    )({
      calls: [
        {
          to: contract.address,
          abi: contract.abi,
          functionName: "send",
          args: [matchId, lengths, data],
        },
      ],
      account: client.account! as SmartAccount,
      // TODO: add matchId logic
      maxFeePerGas: 10_000n,
      maxPriorityFeePerGas: 1n,
      verificationGasLimit: 1_000_000n,
      preVerificationGas: 100_000n,
      callGasLimit: 1_000_000n,
      paymasterPostOpGasLimit: 100_000n,
      paymasterVerificationGasLimit: 100_000n,
    });
    logTime("roundtrip: send user operation took");
    const receipt = await getAction(client, getUserOperationReceipt, "getUserOperationReceipt")({ hash: userOpHash });
    logTime("roundtrip: get user operation receipt took");
    txHash = receipt.receipt.transactionHash;
  }

  await storeSync.waitForTransaction(txHash);
  logTime("roundtrip: wait for transaction took");
  const roundtrip = Date.now() - timeBefore;

  logTime(`roundtrip: full took ${roundtrip}`);
  return { txHash, roundtrip };
}

type ProcessBatchOptions = {
  ownDoomClientId: Hex;
  batch: {
    lengths: readonly number[];
    packets: Hex;
  };
};
export function processBatch({ ownDoomClientId, batch }: ProcessBatchOptions): void {
  let cursor = 0;
  for (const length of batch.lengths) {
    const packet = sliceHex(batch.packets, cursor, cursor + length);
    cursor += length;
    const to = sliceHex(packet, 0, 4);
    if (to === ownDoomClientId) {
      // Cut off the `to` bytes
      inbound.next(sliceHex(packet, 4));
    } else {
      // ignoring unrelated package
    }
  }
}
